jQuery(document).ready(function ($) {
	var rellax = new Rellax('.rellax');
});